// ABOUTME: Picks the detail layout a custom page shows: its own, or the one of the page named by detailLayoutFrom.
// ABOUTME: One level only; a missing, inaccessible, chained or self reference keeps the page's own layout.

import { CustomPage } from '../types';

/**
 * `accessiblePages` are the pages the user can open (useCustomPages already drops the others), so
 * a reference to a page behind a role the user lacks falls back to the page's own layout.
 */
export function resolveDetailLayout(
    page: CustomPage,
    accessiblePages: CustomPage[],
): CustomPage['detailLayout'] {
    const sourceSlug = page.detailLayoutFrom;
    if (!sourceSlug || sourceSlug === page.slug) return page.detailLayout;

    const source = accessiblePages.find(candidate => candidate.slug === sourceSlug);
    // A source that borrows its own layout elsewhere is not followed: no chains, no cycles.
    if (!source || source.detailLayoutFrom) return page.detailLayout;

    return source.detailLayout;
}
